// TTI (Time to Interactive) 指标已废弃，tti-polyfill 不再维护且与 ESM 不兼容
// 保留接口兼容性，始终返回 -1 表示不支持
export default async function getTTI(): Promise<number> {
  return Promise.resolve(-1)
}
